module.exports = __webpack_public_path__ + "img/preview.20d7e26b.png";